import { ValidationError } from "@common/types";

export class CriterionEditorViewModel
{
    opened: boolean = false;

    criterionId: number | null = null;
    name: string | null = null;
    description: string | null = null;

    isGoal: boolean | null = null;

    nameError: string | null = null;

    show(criterionId: number, name: string, description: string | null, isGoal: boolean)
    {
        this.criterionId = criterionId;
        this.name = name;
        this.description = description;
        this.isGoal = isGoal;
        this.clearValidationErrors();

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.criterionId = null;
        this.name = null;
        this.description = null;
        this.isGoal = null;
        this.clearValidationErrors();
    }

    clearValidationErrors()
    {
        this.nameError = null;
    }

    displayValidationErrors(errors: ValidationError[])
    {
        for (const error of errors)
        {
            if (error.ErrorCode === "Name.AlreadyExists")
            {
                this.nameError = error.Error;
            }
            else if (error.ErrorCode === "Name.Required")
            {
                this.nameError = error.Error;
            }
            else if (error.ErrorCode === "Name.MinLength")
            {
                this.nameError = error.Error;
            }
            else if (error.ErrorCode === "Name.MaxLength")
            {
                this.nameError = error.Error;
            }
        }
    }
}